(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-trackbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-form')) {
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.findSubmitButton();
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }

      findSubmitButton() {
        return this.form ? this.form.querySelector('button[type="submit"], input[type="submit"]') : null;
      }

      disableSubmitButton() {
        if (this.submitButton) {
          this.submitButton.disabled = true;
          this.submitButton.classList.add('product-form__submit-button--pulsing');
        }
      }

      enableSubmitButton() {
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove('product-form__submit-button--pulsing');
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        this.disableSubmitButton();

        let cartBeforeSubmission;
        try {
          const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
          cartBeforeSubmission = await cartResponse.json();
        } catch (e) {
          cartBeforeSubmission = null;
        }

        const config = {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        };

        const formData = new FormData(this.form);

        this.dispatchEvent(
          new CustomEvent('product-form:submit:before', {
            bubbles: true,
            detail: { form: formData },
            cancelable: true,
          }),
        );

        await new Promise((resolve) => queueMicrotask(resolve));

        config.body = formData;

        const cartRequestEvent = new CustomEvent('product-form:cart:request', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            config: config,
            cartBefore: cartBeforeSubmission,
            resolve: (responseData) => this.resolveCartRequest(responseData),
            reject: (error) => this.rejectCartRequest(error),
          },
        });

        const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
        let responseData;

        try {
          if (cartRequestHandled) {
            responseData = await this.waitForCartResponse();
          } else {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);
            responseData = await response.json();
            if (!response.ok) throw responseData;
          }

          const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
          const cartAfterSubmission = await cartResponse.json();

          this.dispatchEvent(
            new CustomEvent('product-form:submit:success', {
              bubbles: true,
              detail: {
                form: formData,
                response: responseData,
                cart: cartAfterSubmission,
              },
            }),
          );

          if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
            this.dispatchEvent(
              new CustomEvent('product-form:cart:update', {
                bubbles: true,
                detail: {
                  cart: cartAfterSubmission,
                  form: formData,
                  response: responseData,
                },
              }),
            );
          }

          const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
            bubbles: true,
            cancelable: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission,
            },
          });

          const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);

          if (!navigationPrevented) {
            window.location.href = `${window.Shopify.routes.root}cart`;
          }
        } catch (error) {
          this.dispatchEvent(
            new CustomEvent('product-form:submit:error', {
              bubbles: true,
              detail: {
                form: formData,
                cart: cartBeforeSubmission,
                error: error,
              },
            }),
          );
        } finally {
          this.enableSubmitButton();
        }
      }

      waitForCartResponse() {
        return new Promise((resolve, reject) => {
          this._cartRequestResolver = { resolve, reject };
          const timeout = setTimeout(() => {
            if (this._cartRequestResolver) {
              delete this._cartRequestResolver;
              reject(new Error('Cart request timeout'));
            }
          }, 30000);
          this._cartRequestResolver.timeout = timeout;
        });
      }

      resolveCartRequest(responseData) {
        if (this._cartRequestResolver) {
          clearTimeout(this._cartRequestResolver.timeout);
          this._cartRequestResolver.resolve(responseData);
          delete this._cartRequestResolver;
        }
      }

      rejectCartRequest(error) {
        if (this._cartRequestResolver) {
          clearTimeout(this._cartRequestResolver.timeout);
          this._cartRequestResolver.reject(error);
          delete this._cartRequestResolver;
        }
      }

      hasCartChanged(cartBefore, cartAfter) {
        if (!cartBefore || !cartAfter) return true;
        return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
      }
    }

    customElements.define('product-form', ProductForm);
  }

  document.addEventListener('product-form:cart:navigate', function (event) {
    if (typeof theme !== 'undefined' && theme.settings && theme.settings.cartType !== 'page') {
      event.preventDefault();
    }
  });
  document.addEventListener('product-form:submit:success', function () {
    document.querySelectorAll('.js-qty__num').forEach(function(input) {
      input.value = 1;
    });
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
